import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import Attachmentlist from "./Attachmentlist";


const MomDrawer = ({
  showMom,
  setShowMom,
  meetingInfo,
  userid,
  attachments
}) => {
console.log(attachments,"vgdhcshjaksl;")
      
      const [meetingInfoState, setMeetingInfo] = useState("");

  return (
    <div className={`momDrawer ${showMom ? "open" : ""}`}>

      <div className="momDrawerHeader">
        <span className="momdes">Minutes Of Meeting</span>

        <p
          style={{ marginBottom: "0px" }}
          onClick={() => setShowMom(false)}
          className="close-iconmom"
        >
          <AiOutlineClose />
        </p>
      </div>

      <div className="momDrawerBody">

        <div className="momSection" style={{ maxHeight: "200px" }}>
          <textarea
            className="momInput"
            value={meetingInfoState}
            onChange={(e) => setMeetingInfo(e.target.value)}
            placeholder="Update MOM..."
          />
        </div>

        <div className="attachmentSection">
          <p className="attachTitle">Attachments</p>

          <div className="attachmentGrid">

            <div className="addAttachment">+</div>
            <div className="attachmentList">
<Attachmentlist list={attachments}/>
            </div>
            
          </div>
        </div>

      </div>

    </div>
  );
};

export default MomDrawer;